import React, {
  useEffect,
  useReducer,
  useState,
} from 'react';

import { useAlert } from 'react-alert';
import {
  Link,
  Redirect,
} from 'react-router-dom';
import { Tooltip } from 'react-tippy';

import Loader from '../../components/loader';
import { PasswordField } from '../../components/password_field';
import { register } from '../../utils/api';
import { config } from '../../utils/constants';
import { isLoggedIn } from '../../utils/helpers';

function registerReducer(state, action) {
    switch (action.type) {
        case "field": {
            return {
                ...state,
                [action.field]: action.value,
            };
        }
        case "register": {
            return {
                ...state,
                is_loading: true,
                error: {},
            };
        }
        case "error": {
            return {
                ...state,
                is_loading: false,
                error: action.value,
            };
        }
        case "success": {
            return {
                ...state,
                is_loading: false,
            };
        }
        default: {
            return state;
        }
    }
}

const initialState = {
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    agree: false,
    is_loading: false,
    error: {},
};

export default function Register({ history }) {
    const [state, dispatch] = useReducer(registerReducer, initialState);
    const [hint, showHint] = useState(false);
    const {
        first_name,
        last_name,
        email,
        password,
        agree,
        is_loading,
        error,
    } = state;
    const alert = useAlert();
    useEffect(() => {
        const query = new URLSearchParams(history.location.search);
        const email = query.get("email");
        if (email) {
            dispatch({
                type: "field",
                field: "email",
                value: email,
            });
        }
    }, []);
    if (isLoggedIn()) {
        localStorage.setItem(
            "redirect_intended",
            history.location.pathname + history.location.search
        );
        return <Redirect to={"/"} />;
    }
    const onSubmit = async (e) => {
        e.preventDefault();
        // console.log("submitted");
        dispatch({ type: "register" });
        try {
            const response = await register({
                password,
                last_name,
                first_name,
                email,
            });
            // console.log(response);
            if (response.data) {
                alert.success(response.data.message);
                dispatch("success");
                history.push("/verify/email?email=" + email);
                // alert.success("Please login now");
            } else {
                alert.error(response.message);
                dispatch({ type: "error" });
            }
        } catch (e) {
            // console.log(e);
            let message = "An error occurred";
            if (e.response && e.response.data) {
                message = e.response.data.message;
                dispatch({ type: "error", value: e.response.data.error });
            }
            alert.error(message);
        }
    };
    return (
        <div className="text-black bg-white">
            {is_loading && <Loader />}
            <div className="md:flex justify-between items-center py-5">
                <div className="ml-10 md:ml-16">
                    <img
                        src={require("./../../assets/odiopay-logo-navy-blue.svg")}
                        alt={"Odio Logo"}
                    />
                </div>
                <p className="mr-10 flex items-center justify-end mt-5 md:mt-0">
                    <span className="whitespace-no-wrap">
                        Already a member?{" "}
                        <Link className="text-red" to={"/login"}>
                            Sign in
                        </Link>
                    </span>
                    <i className="material-icons ml-3 p-1 bg-white rounded-full text-black shadow-lg">
                        more_vert
                    </i>
                </p>
            </div>

            <div className="md:flex md:mx-auto md:w-10/12 mt-2">
                <div className="hidden relative lg:block bg-k-blue w-1/2">
                    <img
                        src={require("./../../assets/ODIO-LADY.png")}
                        alt=""
                        className="w-full pt-10 h-full"
                    />
                    <h5 className="absolute top-0 left-0 text-4xl w-7/12 ml-16 mt-10 text-white font-semibold">
                        Enjoy more ways to make payments anytime.
                    </h5>
                </div>
                <div className="lg:w-1/2 md:mx-auto mx-5 pb-10 md:pb-0 md:px-10 pr-0 md:pl-10">
                    <div className="container">
                        <h3 className="font-bold text-2xl text-k-purple mb-16">
                            Sign up for Odiopay
                        </h3>
                        {/*<div className="mt-10 flex space-y-3 md:space-y-0 md:space-x-4 flex-col md:flex-row ">*/}
                        {/*    <button className="bg-blue-100 shadow-lg text-blue-900 font-semibold py-2 px-4 rounded-full">*/}
                        {/*        <img*/}
                        {/*            className="h-10 inline pr-3"*/}
                        {/*            src={require("./../../assets/gimg.png")}*/}
                        {/*            alt="google sign in"*/}
                        {/*        />{" "}*/}
                        {/*        Sign in with Google*/}
                        {/*    </button>*/}
                        {/*    <button className="bg-blue-100 shadow-lg text-blue-900 font-semibold py-2 px-4 rounded-full">*/}
                        {/*        <img*/}
                        {/*            className="h-10 inline pr-3"*/}
                        {/*            src={require("./../../assets/fimg.png")}*/}
                        {/*            alt="facebook sign in"*/}
                        {/*        />{" "}*/}
                        {/*        Sign in with Facebook*/}
                        {/*    </button>*/}
                        {/*</div>*/}

                        {/*<div className="mt-8 w-10">*/}
                        {/*    <hr />*/}
                        {/*</div>*/}

                        {/*<p className="text-gray-500 text-sm mt-5 mb-10">*/}
                        {/*    Or sign up with email address*/}
                        {/*</p>*/}

                        <form onSubmit={onSubmit}>
                            <div className="md:flex mt-5">
                                <div className="md:w-1/2 md:mr-8">
                                    <label>First Name</label>
                                    <input
                                        required
                                        name="first_name"
                                        type="text"
                                        value={first_name}
                                        onChange={(e) =>
                                            dispatch({
                                                type: "field",
                                                field: "first_name",
                                                value: e.currentTarget.value,
                                            })
                                        }
                                        className="block w-full bg-blue-100 rounded-full h-12"
                                    />
                                </div>
                                <div className="md:w-1/2 mt-4 md:mt-0">
                                    <label>Last Name</label>
                                    <input
                                        required
                                        name="last_name"
                                        type="text"
                                        value={last_name}
                                        onChange={(e) =>
                                            dispatch({
                                                type: "field",
                                                field: "last_name",
                                                value: e.currentTarget.value,
                                            })
                                        }
                                        className="block w-full bg-blue-100 rounded-full h-12 "
                                    />
                                </div>
                            </div>
                            <div className="md:flex mt-5">
                                <div className="md:w-1/2 md:mr-8">
                                    <label>Email</label>
                                    <input
                                        required
                                        name="email_address"
                                        type="email"
                                        value={email}
                                        onChange={(e) =>
                                            dispatch({
                                                type: "field",
                                                field: "email",
                                                value: e.currentTarget.value,
                                            })
                                        }
                                        className="block w-full bg-blue-100 rounded-full h-12"
                                    />
                                    {error.email && (
                                        <span className="text-red-600">
                                            {error.email}
                                        </span>
                                    )}
                                </div>
                                <div className="md:w-1/2 mt-3 md:mt-0">
                                    <label className="flex items-center">
                                        Password{" "}
                                        <PasswordHint
                                            show={hint}
                                            password={password}
                                        />
                                    </label>
                                    <PasswordField
                                        required
                                        name="password"
                                        type="password"
                                        value={password}
                                        pattern={config.PASSWORD_PATTERN}
                                        onFocus={() => showHint(true)}
                                        onBlur={() => showHint(false)}
                                        onChange={(e) =>
                                            dispatch({
                                                type: "field",
                                                field: "password",
                                                value: e.currentTarget.value,
                                            })
                                        }
                                        className="block w-full bg-blue-100 rounded-full h-12 "
                                    />
                                    {error.password && (
                                        <span className="text-red-600">
                                            {error.password}
                                        </span>
                                    )}
                                </div>
                            </div>
                            <div className="mt-5">
                                <input
                                    required
                                    className="h-4 w-4 bg-blue-400 mr-3 "
                                    value={agree}
                                    onChange={(e) =>
                                        dispatch({
                                            type: "field",
                                            field: "agree",
                                            value: e.currentTarget.checked,
                                        })
                                    }
                                    type="checkbox"
                                    name="agree"
                                />
                                <span>
                                    Creating an account means you’re okay with
                                    our{" "}
                                    <Link
                                        className="font-semibold"
                                        to="/terms-of-service"
                                    >
                                        Terms of Service
                                    </Link>
                                    ,{" "}
                                    <Link
                                        className="font-semibold"
                                        to="/privacy-policy"
                                    >
                                        Privacy Policy
                                    </Link>
                                    , and our default{" "}
                                    <Link
                                        className="font-semibold"
                                        to="/privacy-policy"
                                    >
                                        Notification Settings
                                    </Link>
                                    .
                                </span>
                            </div>
                            <button
                                className={
                                    (!agree ? "opacity-50" : "") +
                                    " mt-8 rounded-full focus:outline-none bg-primary text-white font-bold text-xl py-3 px-16"
                                }
                            >
                                Create Account
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export function PasswordHint({ password, show, align = "left" }) {
    const [hint, showHint] = useState(false);

    const validate = (pattern) => {
        const re = new RegExp(pattern);
        const test = re.test(password);
        return test;
    };
    return (
        <Tooltip
            title="Password hint"
            position="top"
            arrow={true}
            open={show || hint}
            theme={"light"}
            html={
                <ul className="text-left text-xs list-disc space-y-2">
                    <li className="flex items-center">
                        <ShowCheckMark
                            show={validate("[A-Z]")}
                            text={
                                "Passwords must contain at least 1 upper case letter"
                            }
                        />
                    </li>
                    <li className="flex items-center">
                        <ShowCheckMark
                            show={validate("[a-z]")}
                            text="Passwords must contain at least 1 lower case letter"
                        />
                    </li>
                    <li className="flex items-center">
                        <ShowCheckMark
                            show={validate("[@$!%*#?&]")}
                            text="Passwords must contain at least 1 special character"
                        />
                    </li>
                    <li className="flex items-center">
                        <ShowCheckMark
                            show={validate("[0-9]")}
                            text="Passwords must contain at least 1 number"
                        />
                    </li>
                    <li className="flex items-center">
                        <ShowCheckMark
                            show={password.length > 8}
                            text="Passwords must contain at least 8 characters in length"
                        />
                    </li>
                </ul>
            }
        >
            <i className="material-icons text-sm text-blue-500 pl-2">
                help_outline
            </i>
        </Tooltip>
    );
}

function ShowCheckMark({ show, text }) {
    return (
        <>
            {show ? (
                <i className="material-icons text-sm pr-2 text-green-600">
                    check_circle
                </i>
            ) : (
                <i className="pr-6"></i>
            )}
            <span className={show && "font-bold leading-tight"}>{text}</span>
        </>
    );
}
